<template>
  <b-container>
    <b-alert v-model="form.state.errors" variant="danger">{{ $t('signupOH.errors.general-code') }}</b-alert>
    <b-form @submit.stop.prevent="signUp" v-if="!userRegistered">
      <b-row>
        <b-col sm="12" md="6" class="px-3">
          <b-form-group>
            <b-form-input type="text" v-model="$v.form.companyCode.$model" :placeholder="$t('signupOH.registerCodeEnt')" @blur="checkCompanyCode" :state="companyCodeIsValid"
              @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterCode') }}</b-form-invalid-feedback>
          </b-form-group>

          <transition name="slide-fade">
            <b-form-group v-if="codeInfo.generic">
              <b-form-input type="text" v-model="$v.form.reservationNumber.$model" :placeholder="reservationNumberPlaceholder" :state="validateState('reservationNumber')"></b-form-input>
              <b-form-invalid-feedback>{{ reservationNumberErrorMsg }}</b-form-invalid-feedback>
            </b-form-group>
          </transition>
          
          <transition name="slide-fade">
            <b-form-group v-if="employeeGroupFieldIsVisible">
              <base-select v-model="$v.form.employeeGroup.$model" :options="codeInfo.employeeGroup" valueProp="id" label="groupName" :placeholder="$t('signupOH.center-or-business-unit')" :state="validateState('employeeGroup')" :errorMsg="$t('signupOH.errors.center-or-business-unit')">
              </base-select>
            </b-form-group>
          </transition>

          <transition name="fade">
            <base-input v-if="employeeNumberFieldIsVisible" v-model="$v.form.employeeNumber.$model" :state="validateState('employeeNumber')" :errorMsg="$t('signupOH.errors.employee-number')" :placeholder="$t('signupOH.employee-number')"></base-input>
          </transition>

          <transition name="slide-fade">
            <b-row v-if="isTravelCompany">
              <b-col sm="12" md="12">
                <base-datepicker v-model="$v.form.reservationFromDate.$model" value-as-date :state="validateState('reservationFromDate')" :placeholder="$t('signupOH.checkin-date')" :validator="$v.form.reservationFromDate"></base-datepicker>
              </b-col>
              <b-col sm="12" md="12">
                <base-datepicker v-model="$v.form.reservationToDate.$model" value-as-date :state="validateState('reservationToDate')" :placeholder="$t('signupOH.checkout-date')" :validator="$v.form.reservationToDate" :parentValidators="$v.form"></base-datepicker>
              </b-col>
            </b-row>
          </transition>

          <b-form-group>
            <b-form-input type="text" v-model="$v.form.name.$model" :placeholder="$t('signupOH.registerName')" :state="validateState('name')"
              @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterName') }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <b-form-input type="text" v-model="$v.form.firstSurname.$model" :placeholder="$t('signupOH.registerSurname1')"
              :state="validateState('firstSurname')" @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterSurname1') }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <b-form-input type="text" v-model="$v.form.secondSurname.$model" :placeholder="$t('signupOH.registerSurname2')"
              :state="validateState('secondSurname')" @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterSurname2') }}</b-form-invalid-feedback>
          </b-form-group>

          <div id="genderForm">
            <span class="genderText">{{ $t('signupOH.genderSex') }}</span>
            <radio-button-gender v-model="$v.form.gender.$model" :state="validateState('gender')" :errorMsg="$t('signupOH.errors.enterSex')"></radio-button-gender>
          </div>

          <b-form-group>
        <base-select id="country" :searchable="true" v-model="selectedCountry.selected" :placeholder="$t('signupOH.country')" :options="selectedCountry.options" :label="$i18nHelpers.normalizeProp('name')" valueProp="idCountry"  @change="reCallProvince" :errorMsg="$t('signupOH.errors.enterCountry')" :clearable="false"/>
            <!-- <base-select id="country" v-model="selectCountry.selected" :label="$i18nHelpers.normalizeProp('name')"
              :placeholder="$t('signupOH.country')" :options="selectCountry.options" valueProp="idCountry"></base-select> -->
        <b-form-invalid-feedback v-if="form.trySubmit" :state="selectedCountry.selected != null">{{ $t('signupOH.errors.enterCountry') }}</b-form-invalid-feedback>
     </b-form-group>

     <b-form-group>
      <base-select id="province" :searchable="true" v-model="selectProvince.selected" :placeholder="$t('signupOH.registerYourProvince')" :options="selectProvince.options" :label="$i18nHelpers.normalizeProp('name')" valueProp="id"></base-select>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="selectProvince.selected != null">{{ $t('signupOH.errors.enterProvince') }}</b-form-invalid-feedback>
    </b-form-group>
        </b-col>
        <b-col sm="12" md="6" class="px-3">
          <b-form-group>
            <b-form-input type="text" v-model="$v.form.nif.$model" :placeholder="$t('signupOH.registerNIF')" :state="validateState('nif')"
              @input="resetForm()"></b-form-input>
              <b-form-invalid-feedback v-if="form.trySubmit" :state="form.nif != null ? validateNIF(form.nif) : false">{{ $t('signupOH.errors.enterNIF') }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <b-form-input type="text" v-model="$v.form.email.$model" :placeholder="$t('signupOH.registerEmail')" :state="validateState('email')"
              @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterEmail') }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group>
            <b-form-input type="text" v-model="$v.form.emailConfirmation.$model" :placeholder="$t('signupOH.confirmEmail')"
              :state="validateState('emailConfirmation')" @input="resetForm()"></b-form-input>
            <b-form-invalid-feedback>{{ $t('signupOH.errors.enterConfirmEmail') }}</b-form-invalid-feedback>
          </b-form-group>


          <b-row class="align-items-center">
            <b-col sm="12" md="5" class="pr-3">
              <b-form-group>
        <base-select id="prefix" v-model="selectPrefix.selected" :searchable="true" :placeholder="$t('signupOH.registerPhonePrefix')" :options="selectPrefix.options" :label="$i18nHelpers.normalizeProp('prefixAndCountry')" valueProp="phonePrefix"/>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="selectPrefix.selected != null">{{ $t('signupOH.errors.enterPhonePrefix') }}</b-form-invalid-feedback>
        </b-form-group>             
                </b-col>
                <b-col sm="12" md="7" class="pr-3">
                  <b-form-group>
          <b-form-input type="number" v-model="$v.form.phoneNumber.$model" :placeholder="$t('signupOH.registerPhoneNumber')" :state="validateState('phoneNumber')" @input="resetForm()"></b-form-input>
          <b-form-invalid-feedback v-if="form.trySubmit" :state="form.phoneNumber != null">{{ $t('signupOH.errors.enterPhoneNumber') }}</b-form-invalid-feedback>
        </b-form-group>
            </b-col>
          </b-row>

          <b-form-group>
            <v-select id="lang" v-model="formSelectLang.selected" persistent-hint multiple attach :getOptionLabel="option => $i18nHelpers.normalizeProp('name') === 'name.es' ?option.name.es : option.name.en " 
            :placeholder="$t('signupOH.selectLanguageTxt')" :options="this.formSelectLang.options">
            <template #option="option">
                <slot name="option" :option="option">
                </slot>
              </template>
              <template #no-options>
                  {{ $t('signupOH.no-options') }}
              </template>
                <template #open-indicator="{ attributes }">
          <span v-bind="attributes">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
                  <path id="Path_4_Copy" data-name="Path 4 Copy" d="M0,0,6,6,0,12Z" transform="translate(12) rotate(90)" fill="#8a8a8a"/>
                </svg>
            </span>
                </template>
            </v-select>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="formSelectLang.selected != null">{{ $t('signupOH.errors.enterLang') }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group>
            <div id="genderForm">
            <span class="genderBirthdate">{{ $t('signupOH.birthDate') }}</span>
            </div>
            </b-form-group>
            <b-row class="align-items-center">
                    <b-col sm="12" md="4" class="pr-3">
                      <b-form-group>
                        <base-select id="day" v-model="selectDayBirth.selected" :searchable="true" label="text" :placeholder="$t('signupOH.dayBirth')" :options="this.selectDayBirth.options"></base-select>
                <b-form-invalid-feedback v-if="form.trySubmit" :state="selectDayBirth.selected != null">{{ $t('signupOH.errors.enterDay') }}</b-form-invalid-feedback>
            </b-form-group>             
                    </b-col>
                    <b-col sm="12" md="4" class="pr-3">
            <b-form-group>
                        <base-select id="month" v-model="selectMonthBirth.selected" :searchable="true" label="text" :placeholder="$t('signupOH.monthBirth')" :options="this.selectMonthBirth.options"></base-select>
                <b-form-invalid-feedback v-if="form.trySubmit" :state="selectMonthBirth.selected != null">{{ $t('signupOH.errors.enterMonth') }}</b-form-invalid-feedback>
            </b-form-group>             
                    </b-col>
                    <b-col sm="12" md="4" class="pr-3">
            <b-form-group>
                        <base-select id="year" v-model="selectYearBirth.selected" :searchable="true" label="text" :placeholder="$t('signupOH.yearBirth')" :options="this.selectYearBirth.options"></base-select>
                        <b-form-invalid-feedback v-if="form.trySubmit" :state="selectYearBirth.selected != null">{{ $t('signupOH.errors.enterBirthdate') }}</b-form-invalid-feedback>
            </b-form-group>
            </b-col>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="isDate18orMoreYearsOld(form.birthDate)">{{ $t('signupOH.errors.birthdateMore18') }}</b-form-invalid-feedback>    
            <b-form-invalid-feedback v-if="form.trySubmit" :state="isDateReal(form.birthDate)">{{ $t('signupOH.errors.birthdateMustBeReal') }}</b-form-invalid-feedback>    
          </b-row>
          <base-checkbox v-model="form.termsAccepted" :state="validateState('termsAccepted')">
            <span v-html="$t('signupOH.accept-terms')"></span>
          </base-checkbox>
        </b-col>
      </b-row>
      <b-row class="align-items-center justify-content-center pb-3 text-center">
      <VueRecaptcha
      :sitekey="siteKey"
      :load-recaptcha-script="true"
      @verify="handleSuccess"
      @error="handleError"
    ></VueRecaptcha>
    <b-form-invalid-feedback v-if="form.trySubmit" :state="form.captcha == true">{{ $t('signupOH.errors.captcha') }}</b-form-invalid-feedback>
    </b-row>
      <b-row>
        <b-button type="submit" variant="primary" style="width: 100%">
            {{ $t('signupOH.signup-submit') }}
        </b-button>
        <hr>
        <span>{{ $t('signUp.already-registered') }}, <a href="/sign-in">{{ $t('sign-up-href') }}</a>.</span>
      </b-row>
    </b-form>

    <div id="account-confirmation" v-if="userRegistered">
      <p class="text-left" v-html="$t('signupOH.account-confirmation', { email: $v.form.email.$model })"></p>
    </div>
  </b-container>
</template>

<script>
import { BForm, BFormGroup, BButton, BFormInvalidFeedback, BFormInput, BAlert, BContainer } from 'bootstrap-vue'
import '@/plugins/vue-select'
import BaseDatepicker from '@/components/base/forms/BaseDatepicker'
import BaseCheckbox from '@/components/base/forms/BaseCheckbox'
import helpers from '@/helpers'
import { GET_TRAVEL_COMPANIES } from '@/constants/companiesLandingNames'
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, numeric, email, sameAs } from 'vuelidate/lib/validators'
import { gender, phone, onlyTrue, afterToday, afterDate } from '@/plugins/customValidators'
import RadioButtonGender from '../base/forms/RadioButtonGender.vue'
import BaseMultiSelect from '../base/forms/BaseMultiSelect.vue'
import BaseSelect from '../base/forms/BaseSelect.vue'
import { recaptcha } from '@/constants/recaptcha'
import { VueRecaptcha } from 'vue-recaptcha'
import CompaniesRepository from '@/repositories/CompaniesRepository'
import { BARCELO_SUBDOMAIN, IBEROSTAR_SUBDOMAIN, WAMOS_SUBDOMAIN, ASSEGUR_SUBDOMAIN, NAUTALIA_SUBDOMAIN, CARREFOUR_SUBDOMAIN, MSM_SUBDOMAIN } from '@/constants/subdomains'
import { inMx } from '@/helpers/global.helpers'

// Get subdomain from current url
const SUBDOMAIN = helpers.getSubdomain()

export default {
  name: 'patient-sign-up-form',
  mixins: [validationMixin],
  components: {
    BForm,
    BFormGroup,
    BButton,
    BFormInvalidFeedback,
    BFormInput,
    BAlert,
    BContainer,
    'base-select': BaseSelect,
    'base-multiSelect': BaseMultiSelect,
    'radio-button-gender': RadioButtonGender,
    BaseCheckbox,
    BaseDatepicker,
    VueRecaptcha
  },
  props: {
    callback: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      siteKey: recaptcha,
      form: {
        captcha: false,
        email: null,
        emailConfirmation: null,
        name: null,
        firstSurname: null,
        secondSurname: null,
        gender: null,
        countryId: null,
        stateId: null,
        prefixList: [],
        prefix: null,
        csrfToken: null,
        birthDate: null,
        state: {
          waiting: false,
          unauthorized: false,
          errors: false,
          submitted: false
        },
        companyCode: null,
        nif: null,
        phoneNumber: null,
        phonePrefix: null,
        reservationNumber: null,
        employeeGroup: null,
        reservationFromDate: null,
        reservationToDate: null,
        employeeNumber: null,
        languages: null,
        termsAccepted: false
      },
      formSelectLang: {
        options: [],
        selected: null
      },
      selectedCountry: {
        selected: null,
        options: []
      },
      selectProvince: {
        selected: null,
        options: []
      },
      selectPrefix: {
        options: []
      },
      selectDayBirth: {
        selected: null,
        options: [
        { value: '01', text: '01' },
        { value: '02', text: '02' },
        { value: '03', text: '03' },
        { value: '04', text: '04' },
        { value: '05', text: '05' },
        { value: '06', text: '06' },
        { value: '07', text: '07' },
        { value: '08', text: '08' },
        { value: '09', text: '09' },
        { value: '10', text: '10' },
        { value: '11', text: '11' },
        { value: '12', text: '12' },
        { value: '13', text: '13' },
        { value: '14', text: '14' },
        { value: '15', text: '15' },
        { value: '16', text: '16' },
        { value: '17', text: '17' },
        { value: '18', text: '18' },
        { value: '19', text: '19' },
        { value: '20', text: '20' },
        { value: '21', text: '21' },
        { value: '22', text: '22' },
        { value: '23', text: '23' },
        { value: '24', text: '24' },
        { value: '25', text: '25' },
        { value: '26', text: '26' },
        { value: '27', text: '27' },
        { value: '28', text: '28' },
        { value: '29', text: '29' },
        { value: '30', text: '30' },
        { value: '31', text: '31' }
        ]
      },
      selectMonthBirth: {
        selected: null,
        options: [
        { value: '01', text: this.$t('signupMonth.january') },
        { value: '02', text: this.$t('signupMonth.february') },
        { value: '03', text: this.$t('signupMonth.march') },
        { value: '04', text: this.$t('signupMonth.april') },
        { value: '05', text: this.$t('signupMonth.may') },
        { value: '06', text: this.$t('signupMonth.june') },
        { value: '07', text: this.$t('signupMonth.july') },
        { value: '08', text: this.$t('signupMonth.august') },
        { value: '09', text: this.$t('signupMonth.september') },
        { value: '10', text: this.$t('signupMonth.october') },
        { value: '11', text: this.$t('signupMonth.november') },
        { value: '12', text: this.$t('signupMonth.december') }
        ]
      },
      selectYearBirth: {
        selected: null,
        options: []
      },
      errors: {
        email: null,
        password: null
      },
      submitError: null,
      companyCodeIsValid: null,
      codeInfo: { },
      userRegistered: false
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      firstSurname: {
        required
      },
      secondSurname: {
        required
      },
      email: {
        required,
        email
      },
      emailConfirmation: {
        required,
        email,
        sameAsEmail: sameAs('email')
      },
      gender: {
        required,
        gender
      },
      countryId: {
        required,
        numeric
      },
      stateId: {
        required,
        numeric
      },
      birthDate: {
        required,
        isDate18orMoreYearsOld (val) {
          return new Date(new Date(val).getFullYear() + 18, new Date(val).getMonth() - 1, new Date(val).getDay()) <= new Date()
        },
        maxValue (val) {
          return new Date(val) < new Date()
        },
        minValue (val) {
          return new Date(val) > new Date(1900, 0, 1)
        }
      },
      companyCode: {
        required
        /* validCompanyCode () { return this.companyCodeIsValid } */
      },
      nif: {
        required,
        validateNIF (dni) {
          return this.$validators.validateNIF(dni)
        }
      },
      prefixCountry: {
        required
      },
      phoneNumber: {
        required,
        phone
      },
      reservationNumber: {
        required: requiredIf(() => {
          return !this.codeIsGeneric
        })
      },
      employeeGroup: {
        required: requiredIf(() => {
          return !this.employeeGroupFieldIsVisible
        }),
        numeric
      },
      reservationFromDate: {
        required: requiredIf(() => {
          return !this.isTravelCompany
        })
      },
      reservationToDate: {
        required: requiredIf(() => {
          return !this.isTravelCompany
        }),
        afterToday,
        afterDate: afterDate('reservationFromDate')
      },
      employeeNumber: {
        required: requiredIf(() => {
          return !this.employeeNumberFieldIsVisible
        })
      },
      languages: {
        required,
        minLength: minLength(1)
      },
      termsAccepted: {
        required,
        onlyTrue
      }
    }
  },
  methods: {
    validateNIF (dni) {
    return this.$validators.validateNIF(dni)
    },
    validateState (prop) {
      /* eslint-disable no-unused-vars */
      const { $dirty, $error } = this.$v.form[prop]
      return $dirty ? !$error : null
    },
    reCallProvince: function () {
      this.$api.get(`/states/${this.selectedCountry.selected}`).then((response) => {
      this.selectProvince.options = response.data
    })
    this.showDni()
    },
    isDate18orMoreYearsOld () {
      this.form.birthDate = `${this.selectYearBirth.selected}${'-'}${this.selectMonthBirth.selected}${'-'}${this.selectDayBirth.selected}`
       if (new Date(new Date(this.form.birthDate).getFullYear() + 18, new Date(this.form.birthDate).getMonth() - 1, new Date(this.form.birthDate).getDay()) <= new Date()) {
        return true
       } else {
        return false
      }
     },
     isDateReal (val) {
       if (!(val.includes('04-31') || val.includes('02-30') || val.includes('02-31') ||
       val.includes('06-31') || val.includes('09-31') || val.includes('11-31'))) {
        return true
       } else {
        return false
      }
     },
    handleError: function () {
      this.form.captcha = false
      },
     handleSuccess: function () {
       this.form.captcha = true
      },
    formValid: function () {
      this.form.birthDate = `${this.selectYearBirth.selected}${'-'}${this.selectMonthBirth.selected}${'-'}${this.selectDayBirth.selected}`
      return (this.form.name != null && this.form.name !== '') &&
          (this.form.firstSurname != null && this.form.firstSurname !== '') &&
          (this.selectedCountry.selected != null && this.selectedCountry.selected !== '') &&
          (this.selectProvince.selectedServer != null && this.selectProvince.selectedServer !== '') &&
          (this.selectDiscovery != null && this.form.name !== '') &&
          (this.form.email != null && this.form.email !== '') &&
          (this.form.captcha !== null && this.form.captcha !== false) &&
          (this.form.gender !== null) &&
          (this.form.termsAccepted !== null && this.form.termsAccepted !== false) &&
          (this.form.dataVerification !== null && this.form.dataVerification !== false) &&
          (this.form.emailConfirmation != null && this.form.emailConfirmation !== '') &&
          (this.form.email === this.form.emailConfirmation) &&
          this.selectPrefix.selected != null &&
          (this.form.birthDate != null) &&
          (this.selectYearBirth.selected != null) &&
          (this.selectMonthBirth.selected != null) &&
          (this.selectDayBirth.selected != null) &&
          this.isDate18orMoreYearsOld(this.form.birthDate) &&
          this.isDateReal(this.form.birthDate) &&
          this.validationDateOlderThan18(this.form.birthDate) &&
          this.form.phoneNumber != null &&
          this.formSelectLang.selected != null &&
          /^\d{6,14}$/.test(this.form.phoneNumber) &&
          (this.form.nif != null) && this.validateNIF(this.form.nif)
    },
     signUp: function () {
      const _this = this
      this.$v.form.$touch()
      this.form.trySubmit = true
      var maleRole = false
      this.form.state.submitted = true
      this.form.state.waiting = true
      if (this.form.gender === 'H') maleRole = true
      /* this.resetForm()
      this.form.state.submitted = true */
      if (this.formValid !== false) {
        var lng = []
      this.formSelectLang.selected.map((x, i) => {
        lng.push(x.id)
      })
        this.$api.post('CreateUser', {
          ClientReturnUrl: encodeURIComponent(_this.$route.query.returnUrl || (_this.$route.query.ReturnUrl || null)),
          role: 'Paciente',
          codPromotion: this.form.companyCode.trim(),
          portal: this.portal,
          firstName: this.form.name.trim(),
          lastName1: this.form.firstSurname.trim(),
          lastName2: this.form.secondSurname != null ? this.form.secondSurname.trim() : null,
          male: maleRole,
          female: !maleRole,
          idCountry: this.selectedCountry.selected,
          idProvince: this.selectProvince.selectedServer,
          languages: lng,
          prefix: this.selectPrefix.selected,
          phone: this.form.phoneNumber,
          dni: this.form.nif,
          email: this.form.email,
          bornDate: this.form.birthDate,
          reservationNumber: this.form.reservationNumber,
          employeeGroup: this.form.employeeGroup,
          reservationFromDate: this.form.reservationFromDate,
          reservationToDate: this.form.reservationToDate,
          employeeNumber: this.form.employeeNumber
        }).then((response) => {
          this.defaultLoginCallback(response)
        }).catch((error) => {
          if (error) {
            this.form.state.errors = true
            this.form.state.waiting = false
            return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: false } })
          }
        })
      } else {
        this.form.state.waiting = false
      }
    },
    defaultLoginCallback (response) {
      if (response.data) {
        switch (response.data.code) {
          case 200:
          return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: true } })
          case 400:
            this.submitError = this.$t('error-alreadyregister')
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          case 403:
            this.submitError = response.data.message
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          default:
            this.form.state.errors = true
            this.form.state.waiting = false
            break
        }
      } else {
        this.form.state.errors = true
        this.form.state.waiting = false
      }
    },
    async checkCompanyCode () {
      let code = null
      if (!this.$v.form.companyCode.$model) {
        this.companyCodeIsValid = null
        return
      }
      await CompaniesRepository.getCode(this.$v.form.companyCode.$model).then((response) => {
        code = response.data
        this.codeInfo = code
        const clientNumberInfoDialogMsg = this.$te(`signupOH.info.reservationNumber.${this.$v.form.companyCode.$model}`)
        if (clientNumberInfoDialogMsg) {
					this.$store.dispatch('showSharedDialog', { content: this.$t(`signupOH.info.reservationNumber.${this.$v.form.companyCode.$model}`) })
        }
      })
      this.companyCodeIsValid = !!code
    }
  },
  computed: {
    emailValidation: function () {
      return this.$validators.validate(this.form.email, ['required', 'email'], this.form.state.submitted)
    },
    emailMatches () {
      return this.form.state.submitted ? this.form.email === this.form.emailConfirmation : null
    },
    passwordValidation: function () {
      return this.$validators.validate(this.form.password, ['required', 'password'], this.form.state.submitted)
    },
    requiredValidation () {
      return prop => {
        return this.$validators.validate(prop, ['required'], this.form.state.submitted)
      }
    },
    nifIsValid () {
      return this.$validators.validate(this.form.nif, ['required'], this.form.state.submitted)
    },
    phoneNumberIsValid () {
      return this.$validators.validate(this.form.phoneNumber, ['required', 'phone'], this.form.state.submitted)
    },
    companyCodePlaceholder () {
      switch (SUBDOMAIN) {
        case BARCELO_SUBDOMAIN:
        case IBEROSTAR_SUBDOMAIN:
          return this.$t('signupOH.reservation-number-or-code')
        case WAMOS_SUBDOMAIN:
        case ASSEGUR_SUBDOMAIN:
          return this.$t('signupOH.certificate-number-or-code')
        case NAUTALIA_SUBDOMAIN:
        case CARREFOUR_SUBDOMAIN:
          return this.$t('signupOH.generic-code')
        case MSM_SUBDOMAIN:
          return this.$t('signupOH.code-provided-by-msm')
        default:
          return this.$t('signupOH.code-provided-by-company-or-entity')
      }
    },
    reservationNumberPlaceholder () {
      switch (SUBDOMAIN) {
        case BARCELO_SUBDOMAIN:
        case IBEROSTAR_SUBDOMAIN:
          return this.$t('signupOH.reservation-number')
        case WAMOS_SUBDOMAIN:
        case ASSEGUR_SUBDOMAIN:
        case NAUTALIA_SUBDOMAIN:
        case CARREFOUR_SUBDOMAIN:
          return this.$t('signupOH.certificate-number')
        case MSM_SUBDOMAIN:
          return this.$t('signupOH.client-number')
        default:
          return this.$t('signupOH.client-number')
      }
    },
    reservationNumberErrorMsg () {
      switch (SUBDOMAIN) {
        case BARCELO_SUBDOMAIN:
        case IBEROSTAR_SUBDOMAIN:
          return this.$t('signupOH.errors.reservation-number')
        case WAMOS_SUBDOMAIN:
        case ASSEGUR_SUBDOMAIN:
        case NAUTALIA_SUBDOMAIN:
        case CARREFOUR_SUBDOMAIN:
          return this.$t('signupOH.errors.certificate-number')
        case MSM_SUBDOMAIN:
          return this.$t('signupOH.errors.client-number')
        default:
          return this.$t('signupOH.errors.client-number')
      }
    },
    requiredOnlyInTravelValidation () {
      return prop => {
        return this.isTravelCompany ? this.$validators.validate(prop, ['required'], this.form.state.submitted) : true
      }
    },
    requiredOnlyInGenericCodesValidation () {
      return prop => {
        return this.codeInfo.generic ? this.$validators.validate(prop, ['required'], this.form.state.submitted) : true
      }
    },
    getCompanyCodeInputState () {
      return !this.form.state.submitted ? this.companyCodeIsValid : (this.requiredValidation(this.form.companyCode) && this.companyCodeIsValid)
    },
    getTermsFormState () {
      return !this.form.state.submitted ? this.termsAccepted : this.termsAccepted === true
    },
    isTravelCompany () {
      return GET_TRAVEL_COMPANIES().includes(SUBDOMAIN)
    },
    employeeGroupFieldIsVisible () {
      return this.codeInfo.employeeGroup && this.codeInfo.employeeGroup.length > 0 && this.codeInfo.employeeGroup.every(group => !group.createdByPatient)
    },
    employeeGroupFreeFieldIsVisible () {
      return this.codeInfo.employeeGroup && this.codeInfo.employeeGroup.length > 0 && this.codeInfo.employeeGroup.every(group => group.createdByPatient)
    },
    employeeNumberFieldIsVisible () {
      return this.codeInfo.employeeNumberRequired
    },
    codeIsGeneric () {
      return this.codeInfo.generic
    }
  },
  mounted () {
    const year = new Date().getFullYear()
      const years = Array.from({length: year - 1900}, (value, index) => 1901 + index).reverse()
      for (let k = 0; k < years.length; k++) {
        this.selectYearBirth.options.push({
          'value': years[k],
          'text': years[k]
        })
      }
    this.$api.get('/languages').then((response) => {
      this.formSelectLang.options = response.data
    })
    this.$api.get('/countries').then((response) => {
      this.selectedCountry.options = response.data
      this.selectPrefix.options = response.data
      // console.log(this.$i18nHelpers.getNormalizedLocale())
      // console.log(this.selectPrefix.selected)
      this.selectedCountry.selected = this.$i18n.locale === 'mx' ? 42 : (this.$i18n.locale === 'es' || this.$i18n.locale === 'en') ? 28 : null
      this.selectPrefix.selected = this.$i18n.locale === 'mx' ? 521 : (this.$i18n.locale === 'es' || this.$i18n.locale === 'en') ? 34 : null
      const selectedCountry = this.selectedCountry.options.find(country => !inMx ? country.idCountry === 28 : country.idCountry === 42)
      this.form.countryId = selectedCountry.idCountry
      this.form.prefixCountry = selectedCountry
    })
    this.$api.get(`/states/${this.selectedCountry.selected ? this.selectedCountry.selected.idCountry : 28}`).then((response) => {
      this.selectProvince.options = response.data
    })
  }
}
</script>

<style lang="scss" scoped>
  span .vs__selected{
    margin-left: 1%;
    font-size: 0.8rem;    
  }

  .v-select {
    // margin: 2% 0px 2% 0px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;

  }
  .vs__selected{
  margin-left: 1rem !important;
  padding: 0 0.8em !important;
  }

  div .v-select .vs--unsearchable{
    margin: 0px !important;
  }

  .vs__selected, .vs__search, .vs__search:focus {
  margin-left: 1rem !important;
  
  }

  .v-select .vs--single .vs--unsearchable{
        margin: 0px !important;
  }

  div .mt-3, button, p, fieldset, .v-select, .custom-checkbox, .my-3 {
      margin-top: 0rem !important;
  }

  #lang{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #prefix{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #country{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #province{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }

  #genderForm{
    // display: inline-flex;
    text-align: left !important;
  }

  .genderText{
    float: left;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    padding: 0rem 2.2rem;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    // margin-right: auto !important;
    // margin-left: auto !important;
  }

  @media (max-width: 1024px) {
    .Body1_OH-sm{
    display:block !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    }
  }



  .headerMenu {
    margin: 22px 133px 0px 4% ;
    // line-height: 2.70 !important;
    // display: block !important;
    // @media (max-width: 1024px) {
    //   margin: auto !important;
    // }
  }

  div  .Body3_rightCol{
      padding-right: 0px !important;
      padding-left: 0px !important;      
  }

  .Body2_OH {
    margin: 5% 0% 0% 12% !important;
}
.Body3_div {
    display: block;
    padding: 8% 0px 8% 10% !important;;
    background-color: #1D1D1E;
    opacity: 87%;
    margin: 0px 0% 0px 0px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/views/SignUp.vue